export enum ProjetListActions {
    GET_PROJET_LIST = 'GET_PROJET_LIST',
}
